import React, { Suspense } from 'react';
import { Box, CircularProgress } from '@mui/material';

import HeroSection from './components/Hero/HeroSection.jsx';

const MazeExperience = React.lazy(
  () => import('./components/Maze/MazeExperience'),
);

const Homepage = () => {
  return (
    <>
      <HeroSection />
      <Suspense
        fallback={
          <Box
            sx={{
              height: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CircularProgress />
          </Box>
        }
      >
        <MazeExperience />
      </Suspense>
    </>
  );
};

export default Homepage;
